import { useEffect, useState, useRef } from 'react';
import Constant from '@/common/constant/Constant';
import { I18n } from 'aws-amplify';
import { Typography } from '@material-ui/core';
import ListPublicRangeDropdown from './ListPublicRangeDropdown';
import ListItemPublicRange from './ListItemPublicRange';
import CircularProgress from '@material-ui/core/CircularProgress';

function RenderMultiPublicRange(props) {
    const [selectPermission, setSelectPermission] = useState(
        Constant.LIST_PERMISSION_PUBLIC_RANGE.BASIC_VIEW
    );

    const handleSelectPermission = value => {
        setSelectPermission(value);
    };
    const [isShowListPublicRange, setIsShowListPublicRange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const menuTriggerRef = useRef(null);
    const [menuCSS, setMenuCSS] = useState({
        top: 0,
        left: 0,
        width: 0,
        height: 0
    });

    useEffect(() => {
        setIsLoading(!props.isLoadDataForPublicRangeDone);
        let dataCSSParent = {
            top: menuTriggerRef.current.offsetTop,
            left: menuTriggerRef.current.offsetLeft,
            width: menuTriggerRef.current.offsetWidth,
            height: menuTriggerRef.current.offsetHeight,
        }
        setMenuCSS(dataCSSParent);
    }, [props.isLoadDataForPublicRangeDone, props.drilldownDataSelected])
    
    const LoadingData = (data) => {
        if (data.isLoading) {
            return (
                <div 
                    className={`loading-panel`} 
                    data-cy="loading-panel"
                    style={{ position: 'absolute',
                        width: menuCSS.width,
                        height: menuCSS.height,
                        top: menuCSS.top,
                        left: menuCSS.left,
                        right: 0,
                        bottom: 0 }}
                >
                    <CircularProgress color="primary" style={{ display: 'block', textAlign: 'center', top: "30%", marginLeft: "-10px", left: "50%", position: "absolute", zIndex: "9999" }} />
                    <div className="loading-blur-panel" data-cy="loading-panel"></div>
                </div>
            );
        }
        return null;
    }

    return (
        <div 
            className="multi_public-range-action"
            ref={menuTriggerRef}
        >
            <LoadingData isLoading={isLoading} />
            <div className="multi_public-range-action-left">
                <span className="option-name label-multi-public-range">
                    <p style={{fontWeight: '550'}}>{I18n.get('EDIT_PUBLIC_RANGE')}</p>
                </span>
                <span className="option-name label-multi-public-range">
                    <p >{I18n.get('DROPDOWN_EDIT_PUBLIC_RANGE')}</p>
                </span>
            </div>

            <div className="multi_public-range-action-right">
                <div className="share-status-cancel">
                    <Typography
                        className="btn-cancel-share-public-range"
                        variant="contained"
                        onClick={e => props?.setIsShowEditRangeMulti(false)}
                    >
                        <span>{I18n.get('COMBTN001')}</span>
                    </Typography>
                </div>
                <div className="group-edit-public-range">
                    <ListPublicRangeDropdown
                        handleSelectPermission={handleSelectPermission}
                        selectPermission={selectPermission}
                    />
                    <div
                        className={`icon-edit-public-range ${
                            isShowListPublicRange ? ' show-list-role' : ''
                        }`}
                    >
                        <ListItemPublicRange
                            setIsShowListPublicRange={setIsShowListPublicRange}
                            selectPermission={selectPermission}
                            setIsShowEditRangeMulti={props?.setIsShowEditRangeMulti}
                            listAdditionalAllRole={props.listAdditionalAllRole}
                            currentSearchParams={props.currentSearchParams}
                            listDataPublicRange={props.listDataPublicRange}
                            setListDataPublicRange={props.setListDataPublicRange}
                            totalTickets={props.totalTickets}
                            setIsShowDialogNotiLimit={props.setIsShowDialogNotiLimit}
                            msgInProcessingIcon={props.msgInProcessingIcon}
                            setMsgInProcessingIcon={props.setMsgInProcessingIcon}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RenderMultiPublicRange;
